enum SyncAction {
  None = "None",
  SyncTags = "SyncTags",
  SyncUsers = "SyncUsers",
}

export default SyncAction;
